import React, { useRef, useEffect, useState } from 'react';
import styles from '../Tooltip/Tooltip.module.scss';
import PropTypes from 'prop-types';

const ChartTooltip = ({
  visible,
  x,
  y,
  content,
  className = '',
  style = {}
}) => {
  const tooltipRef = useRef(null);
  const [position, setPosition] = useState({ left: x, top: y, transformX: '-10%', transformY: '-50%' });

  useEffect(() => {
    if (!visible || !tooltipRef.current) return;

   requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!tooltipRef.current) return;

        const tooltip = tooltipRef.current;
        const tooltipRect = tooltip.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const padding = 10;

        let transformX = '-10%';
        let transformY = '-50%';
        let left = x;
        let top = y;

        const tooltipWidth = tooltipRect.width;
        const tooltipHeight = tooltipRect.height;
        
        const defaultRight = x + (tooltipWidth * 0.9);
        const defaultLeft = x - (tooltipWidth * 0.1);
        const defaultBottom = y + (tooltipHeight * 0.5);
        const defaultTop = y - (tooltipHeight * 0.5);

        if (defaultRight > viewportWidth - padding) {
          transformX = '-100%';
          left = x - 10;
        } else if (defaultLeft < padding) {
          transformX = '0%';
          left = x + 10;
        }

        if (defaultBottom > viewportHeight - padding) {
          transformY = '-100%';
          top = y - 10;
        } else if (defaultTop < padding) {
          transformY = '0%';
          top = y + 10;
        }

        setPosition({ left, top, transformX, transformY });
      });
    });
  }, [visible, x, y]);

  if (!visible) return null;
  return (
    <div
      ref={tooltipRef}
      className={`${styles.tooltipBox} ${className} ${styles.chartTooltipBox}`}
      style={{
        position: 'fixed',
        left: position.left,
        top: position.top,
        pointerEvents: 'none',
        zIndex: 10,
        transform: `translate(${position.transformX}, ${position.transformY})`,
        ...style,
      }}
    >
      {content}
    </div>
  );
};

ChartTooltip.propTypes = {
  visible: PropTypes.bool.isRequired,
  x: PropTypes.number,
  y: PropTypes.number,
  content: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default ChartTooltip;
